import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import Logo from "@/components/Logo";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3 text-sm text-slate-100 placeholder:text-slate-600 focus:border-[#E2C08D]/60 focus:outline-none focus:ring-1 focus:ring-[#E2C08D]/40 transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center hero-grid-bg px-5" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="w-full max-w-md">
        <div className="rounded-2xl border border-white/10 bg-[#10141d]/90 backdrop-blur-xl p-9">
          <div className="flex flex-col items-center text-center">
            <Logo size={48} />
            <h1 className="mt-5 font-display text-3xl font-semibold text-slate-100">Bishwa Mohan — Admin</h1>
            <p className="mt-2 text-sm text-slate-500">Private dashboard. Authorised access only.</p>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <input className={inputCls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" autoComplete="email" />
            <input className={inputCls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" autoComplete="current-password" />
            {error && <p className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-4 py-2.5 text-xs text-rose-300" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="flex w-full items-center justify-center gap-2 rounded-full bg-[#E2C08D] px-6 py-3.5 text-sm font-semibold text-[#0A0C10] hover:bg-[#f0d3a4] disabled:opacity-60 transition-colors">
              {loading ? <Loader2 size={15} className="animate-spin" /> : <Lock size={15} />} Sign In
            </button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-slate-600">
          <Link to="/" className="hover:text-[#E2C08D] transition-colors" data-testid="back-to-site-link">← Back to website</Link>
        </p>
      </motion.div>
    </div>
  );
}
